"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PostMarkerPairs {
    constructor(container) {
        this.container = container;
        this.postMarkerPairs = [];
    }
    set(postMarkerPair) {
        this.postMarkerPairs.push(postMarkerPair);
        this.dispatchPostMarkerPairAdded(postMarkerPair);
    }
    get() {
        return this.postMarkerPairs;
    }
    dispatchPostMarkerPairAdded(postMarkerPair) {
        this.container.dispatchEvent(new CustomEvent('postMarkerPairAdded', { detail: postMarkerPair }));
    }
}
exports.default = PostMarkerPairs;
